(function() {
    'use strict';

    angular
        .module('MW.CoreStream.CsHeader', [
            'MW.Framework.TranslationService'
        ])
        .directive('csHeader', function () {
            return {
                restrict: 'E',
                scope: {
                    itemCount: '=',
                    sortField: '=?',
                    dateRangeDays: '=?',
                    headerText: '<?'
                },
                controllerAs: 'csHeaderController',
                controller: CsHeaderController,
                templateUrl: 'icm-web/views/partials/cs_header'
            };
        })
        .controller('CsHeaderController', [
            '$scope',
            '$translate',
            'translationService',
            CsHeaderController
        ]);

    function CsHeaderController($scope, $translate, translationService) {
        var message;

        this.$translate = $translate;
        this.itemCountMessage = '';
        this.sortFieldMessage = '';
        this.dateRangeMessage = '';

        $scope.$watch('headerText', function(newValue) {
            this.headerText = newValue;
        }.bind(this));

        // getting around a bug in angular 1.2, if we update we can use 'bindToController'
        $scope.$watch('itemCount', function(newValue) {
            if (newValue === -1) {
                return;
            }
            this.itemCount = newValue;

            message = (this.itemCount === 1) ? 'icm-search__map-filter--result-count' : 'icm-search__map-filter--results-count';
            if(!this.itemCount){
                this.itemCount = 0;
            }

            this.$translate(message, {itemCount: this.itemCount}).then(function(translatedMessage) {
                this.itemCountMessage = translatedMessage;
            }.bind(this))
            .catch(function() {});
        }.bind(this));

        $scope.$watch('sortField', function(newValue) {
            message = 'sorted by ' + newValue;
            if(newValue === 'alphabetically') {
                message = 'sorted ' + newValue;
            }
            this.sortField = newValue;

            translationService.getLocalizedString(message, '', true).then(function(translatedMessage) {
                this.sortFieldMessage = translatedMessage;
            }.bind(this))
            .catch(function() {});
        }.bind(this));

        $scope.$watch('dateRangeDays', function(newValue) {
            if (newValue && newValue > -1) {
                newValue = newValue || 14;
                message = 'icm-search__stream-header--' + newValue + '-days';
                this.dateRangeDays = newValue;

                this.$translate(message).then(function(translatedMessage) {
                    this.dateRangeMessage = translatedMessage;
                }.bind(this))
                .catch(function() {});
            }
        }.bind(this));
    }
}());
